import { queryOptions, useQuery } from '@tanstack/react-query';

import { qcTemplatesApi } from '../api/workflows-api';

import { workflowKeys } from './workflow-keys';

export function qcTemplateQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: workflowKeys.qcDetail(storeId, id),
    queryFn: () => qcTemplatesApi.get(storeId, id),
  });
}

export function useQcTemplate(storeId: string, id: string) {
  return useQuery(qcTemplateQueryOptions(storeId, id));
}
